import axios from 'axios';

// Always use current browser origin for API calls.
// This ensures custom domains (e.g., molecuai-demo.junolabs.ai) work
// without cross-origin issues. The /api prefix routes to the backend
// via the ingress/proxy in both preview and deployed environments.
const API = window.location.origin;

const api = axios.create({
  baseURL: `${API}/api`,
  withCredentials: true,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('access_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (res) => res,
  async (err) => {
    if (err.response?.status === 401 && !err.config._retry) {
      err.config._retry = true;
      try {
        await axios.post(`${API}/api/auth/refresh`, {}, { withCredentials: true });
        return api(err.config);
      } catch {
        localStorage.removeItem('access_token');
        window.location.href = '/login';
      }
    }
    return Promise.reject(err);
  }
);

export default api;
